import { TextInput } from "@/lib/Components/Form/Inputs/TextInput";
import { useFormState } from "@/lib/Components/Form/Hooks/useFormState";
import { generateSlug } from "@/lib/Utils/string";
import { UpdateBlogTagInput } from "@/gql/graphql";

export function BlogTagForm() {
  const { values, setFieldValue } = useFormState<UpdateBlogTagInput>();

  return (
    <>
      <TextInput
        autoFocus
        name="name"
        label="Name"
        className="col-span-6"
        onChange={(val) => {
          if (val && !values.slug) {
            setFieldValue("slug", generateSlug(val));
          }
        }}
      />
      <TextInput
        name="slug"
        label="Slug"
        className="col-span-6"
        description="Lowercase and dashes only"
      />
    </>
  );
}
